import { isVisibleToCustomers } from '@esentai/core/features/productCategory/selectors';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { moveCategoryUp } from '@/features/productsCategoryPage/actions';

import MoveUpButton from './component';

const mapStateToProps = (state, { itemId }) => ({
  isVisible: isVisibleToCustomers(state, itemId),
});

const mapDispatchToProps = (dispatch, { itemId }) => ({
  onClick: () => dispatch(moveCategoryUp(itemId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(MoveUpButton);
